import compileEnhancedMarkdown from '../../resources/js/components/EnhancedMarkdown/helpers/compileEnhancedMarkdown';
import type { default as UseGameHook } from '../../resources/js/contexts/useGame';
import flattenChildren from './flattenChildren';
import React from 'react';
import EnhancedMarkdownIf from '../../resources/js/components/EnhancedMarkdown/components/EnhancedMarkdownIf';

export default function extractHeadingComponentsFromEnhancedMarkdown(
  markdown: string,
  context: { pageViewModels: { game: ReturnType<typeof UseGameHook> } }
): JSX.Element[] {
  const output = compileEnhancedMarkdown(
    markdown,
    {
      h1: (props: Record<string, unknown>) => <h2 {...props} />,
      h2: (props: Record<string, unknown>) => <h3 {...props} />,
      h3: (props: Record<string, unknown>) => <h4 {...props} />,
      h4: (props: Record<string, unknown>) => <h5 {...props} />,
      h5: (props: Record<string, unknown>) => <h6 {...props} />,
      h6: (props: Record<string, unknown>) => <h6 {...props} />,
      If: EnhancedMarkdownIf,
    },
    context,
    true
  );

  return flattenChildren(output.props.children, context.pageViewModels?.game);
}
